import { TableField } from "../../table-field";

const codigoBanco: TableField = {
    key: "CodigoBanco",
    label: "Código do Banco",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
};
const codigoAgencia: TableField = {
    key: "CodigoAgencia",
    label: "Código da Agência",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
};
const numeroContBancaria: TableField = {
    key: "NumeroContBancaria",
    label: "Nº da Conta Bancária",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
};
const numeroContBancariaNovo: TableField = {
    key: "NumeroContBancariaNovo",
    label: "Nº Novo da Conta Bancária",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
    formatter: (value: string) => value ?? " - ",
};
const descricaoContBancaria: TableField = {
    key: "DescricaoContBancaria",
    label: "Descrição da Conta Bancária",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
};
const acoes: TableField = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
}

export const fieldsContasCaixa: TableField[] = [
    codigoBanco,
    codigoAgencia,
    numeroContBancaria,
    numeroContBancariaNovo,
    descricaoContBancaria,
    acoes,
];